import React, { useEffect, useState } from "react";
import SearchBar from "./searchBar";
import { TableContainer } from "./TableContainer";

const Table = (props) => {
	const { data } = props;


	const [sortedData, setSortedData] = useState(data);
	const [searchValue, setSearchValue] = useState("");
	const [orderArgs, setOrderArgs] = useState(null);
	const [raz, setRaz] = useState(false);

	const [Columns, setColumns] = useState([
		{ name: "Nom", slug: "name" },
		{ name: "Lieu", slug: "ville" },
		{ name: "Médias", slug: "categories" },
		{ name: "Date", slug: "date" },
	]);

	const handleSearchChange = (value) => {
		setSearchValue(value);
	};

	useEffect(() => {
		const sorted = [];

		Object.keys(data).forEach((key) => {
			const project = data[key];
			Object.keys(project).forEach((keyProject) => {
				const ok = [
					"categories",
					"name",
					"date",
					"ville",
				];
				if (ok.includes(keyProject)) {
					let value = project[keyProject].name;

					if (value !== undefined && value !== "") {
						if (
							value
								.toLowerCase()
								.includes(searchValue.toLowerCase())
						) {
							if (!sorted.includes(data[key])) {
								sorted.push(data[key]);
							}
						}
					}
				} else {
				}
			});
		});
		setSortedData(sorted);
	}, [data, searchValue]);

	useEffect(() => {
		if (orderArgs) {
			const sortByCriteria = (data, orderArgs) => {

				const { slug, sens } = orderArgs;

				data.sort((a, b) => {
					let valueA = a[slug].slug;
					let valueB = b[slug].slug;

					// if (slug === "name" || slug === "annee") {
					// 	valueA = a[slug].name;
					// 	valueB = b[slug].name;
					// }


					// Ajouter une priorité pour les tailles XL, L, M, S
					// const priorityOrder = { xl: 4, l: 3, m: 2, s: 1 };
					// if (
					// 	slug === "echelle" &&
					// 	typeof valueA === "string" &&
					// 	typeof valueB === "string"
					// ) {
					// 	// Si les valeurs sont dans la liste de priorité, compare leurs priorités
					// 	if (priorityOrder[valueA] && priorityOrder[valueB]) {
					// 		return sens
					// 			? priorityOrder[valueA.toLowerCase()] -
					// 					priorityOrder[valueB.toLowerCase()]
					// 			: priorityOrder[valueB.toLowerCase()] -
					// 					priorityOrder[valueA.toLowerCase()];
					// 	}
					// }


					// if (slug === "categories") {
					// 	valueA = a[slug].map((item) => item.name).join(" ");
					// 	valueB = b[slug].map((item) => item.slug).join(" ");
					// }

					if (
						typeof valueA === "string" &&
						typeof valueB === "string"
					) {
						return sens
							? valueA.localeCompare(valueB, undefined, {
									sensitivity: "base",
							  })
							: valueB.localeCompare(valueA, undefined, {
									sensitivity: "base",
							  });
					} else if (
						typeof valueA === "number" &&
						typeof valueB === "number"
					) {
						return sens ? valueA - valueB : valueB - valueA;
					} else if (
						typeof valueA === "boolean" &&
						typeof valueB === "boolean"
					) {
						return sens
							? valueA === valueB
								? 0
								: valueA
								? -1
								: 1
							: valueA === valueB
							? 0
							: valueA
							? 1
							: -1;
					} else {
						return 0;
					}
				});

				return data;
			};

			const result = sortByCriteria([...sortedData], orderArgs);
			setSortedData(result);
		}
	}, [orderArgs]);

	const handleChangeOrder = (args) => {
		setOrderArgs(args);
	};

	const [searchBarRef, setSearchBarRef] = useState(null);

	const searchBarRefFn = (ref) => {
		setSearchBarRef(ref);
	};

	const fnrazCallBack = () => {
		setSortedData(data);
		setRaz(true);
		setTimeout(() => {
			setRaz(false);
		}, 20);
	};


	return (
		<div className="table">
			<SearchBar
				placeholder="recherchez ici un projet, un mot clé…"
				onInputChange={handleSearchChange}
				SearchBarRef={searchBarRefFn}
				razCallBack={fnrazCallBack}
			/>
			<TableContainer
				data={sortedData}
				columns={Columns}
				onOrderChange={handleChangeOrder}
				searchBarRef={searchBarRef}
				raz={raz}
			/>
		</div>
	);
};

export default Table;